import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function Soliva() {
  return <NeighborhoodPageContent slug="soliva" />;
}